import { useContext } from "react";
import { AppContext } from "../../App";
import "./style.css";
import { Virtual, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { stripHtml, truncateText } from "../functions";
import Label from "../Label";
import { useAppStore } from "../../useAppStore";

export default function Banners({ slidesPerView = 1, customClass = "", breakpoints = {} }) {
  const { popups, cart, getTranslatedString } = useContext(AppContext);
  const { setFilteredPopups } = useAppStore();
  const banners = popups
    ? popups.filter((p) => {
        if (p.type != "banner") return false;
        if (!Array.isArray(p.shops) || p.shops.length == 0) return true;
        if (!cart?.shop_id) return false;
        return p.shops.some((s) => s.id == cart.shop_id);
      })
    : [];
  const isSingleBanner = banners.length === 1;
  const effectiveSlidesPerView = isSingleBanner ? 1 : slidesPerView;
  const effectiveBreakpoints = isSingleBanner ? {} : breakpoints;

  return (
    <div className={"banners " + customClass + (isSingleBanner ? " single-banner" : "")}>
      <div className="swiper-wrapper-container">
        <Swiper
          modules={[Virtual, Autoplay]}
          slidesPerView={effectiveSlidesPerView}
          breakpoints={effectiveBreakpoints}
          spaceBetween={15}
          loop={false}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          virtual
        >
          {banners.map((slide, i) => (
                <SwiperSlide key={`${slide.id}-${i}`} virtualIndex={i}>
                  <div className="inner-container">
                    {slide.img && (
                      <div className="img">
                        <img src={slide.img} />
                      </div>
                    )}
                    <div className="inner-content">

                      <div className="title">{truncateText(stripHtml(getTranslatedString(slide, "title")), 30)}</div>
                      <div className="text">
                        {truncateText(stripHtml(getTranslatedString(slide, "text")), 80)} <button onClick={() => setFilteredPopups([slide])}>
                          <Label number={178} />
                        </button>
                      </div>

                    </div>
                  </div>
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </div>
  );
}
